var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{ref:"input",staticClass:"form-input",attrs:{"type":"text","placeholder":_vm.pattern},domProps:{"value":_vm.display},on:{"input":_vm.onInput}})
}
var staticRenderFns = []

export { render, staticRenderFns }